module.exports = function isFunction (fn) {
  return Object.prototype.toString.call(fn) === '[object Function]'
}



//////////////////
// WEBPACK FOOTER
// ./~/x-is-function/index.js
// module id = 331
// module chunks = 95715928098905 152099450743416